import { SxProps, Typography } from "@mui/material";

import { FieldProps, useRecordContext } from "react-admin";
// import { Customer } from "../types";

interface Props extends FieldProps<any> {
  size?: string;
  sx?: SxProps;
}

const FullNameField = ({
  source = "sFname",
  label = "resources.customers.fields.name",
  size,
  sx,
}: Props) => {
  void source;
  void label;
  void size;
  const record = useRecordContext<any>();
  return record ? (
    <Typography
      variant="body2"
      display="flex"
      flexWrap="nowrap"
      alignItems="center"
      component="div"
      sx={sx}
    >
      {record.sFname} {record.sLname}
    </Typography>
  ) : null;
};

export default FullNameField;
